/**
 * CARRITO-SIN-NATIVOS (SI de Ares #29875, dentro de T143): los textos de la confirmacion del pedido que antes iban en
 * un confirm() nativo y del aviso de mesa que iba en un alert(). Sin DOM, para el check.
 * No cambia el pedido: buildOrden y POST /api/sync/upload siguen igual en CarritoView.js.
 *
 * @module application/carrito/confirmacionPedido
 */

export const MENSAJE_SIN_MESA = 'Elige el número de mesa o toca "Llevar" antes de enviar el pedido.';

/** La mesa como la lee el mesero: 'LLEVAR' = Para llevar; un numero = Mesa N. */
export function mesaEnPalabras(mesa) {
  return mesa === 'LLEVAR' ? 'Para llevar' : `Mesa ${mesa}`;
}

/**
 * Lo que la pantalla muestra antes de enviar: titulo, una fila por dato y el pie.
 * total llega ya formateado por la vista (fmt), para no tener dos formatos de plata.
 */
export function lineasDeConfirmacion({ mesa, vendedor, items, units, total }) {
  return {
    titulo: '¿Enviamos este pedido?',
    filas: [
      mesaEnPalabras(mesa),
      `Vendedor: ${vendedor}`,
      `Productos: ${items} · Unidades: ${units}`,
      `Total: ${total}`,
    ],
    pie: 'Va a Nexo Desktop; en caja lo ven en su próxima sincronización.',
  };
}
